export const UDPATE_PAPERLESS_EOB_MESSAGE = {
  PAPERLESS: {
    SUCCESS: {
      STATUS: "Success",
      TITLE: "Success",
      MESSAGE: "You will now only receive electronic EOBs.",
    },
    FAILURE: {
      STATUS: "Failed",
      TITLE: "Failed",
      MESSAGE: "Something went wrong",
    },
  },
  DONT_ASK_AGAIN: {
    SUCCESS: {
      STATUS: "Success",
      TITLE: "We won't show this reminder again",
      MESSAGE:
        "Your EOB delivery preferences have not changed. To manage them, visit your Profile.",
    },
    FAILURE: {
      STATUS: "Failed",
      TITLE: "Failed",
      MESSAGE: "Something went wrong",
    },
  },
  GENERIC_FAILURE: {
    STATUS: "Failed",
    TITLE: "We couldn't save your preference.",
    MESSAGE:
      "Something went wrong on our end and your change wasn't applied. You can update your EOB delivery preferences anytime from your Profile.",
  },
} as const;
